import * as Yup from "yup";

const Validation = Yup.object({

  name: Yup.string().required("Please enter name!"),
  language: Yup.string().required("Please select Language!"),
});

export default Validation;